import { createReducer, on } from '@ngrx/store';
import { DailyLead, DailyLeadRun, IcpAdjustmentNotification, PaginationMeta } from '../../pages/leads-legacy/lead.model';
import * as DailyLeadActions from './daily-lead.actions';

export interface DailyLeadLegacyState {
  leads: DailyLead[];
  selectedLead: DailyLead | null;
  loading: boolean;
  generating: boolean;
  detailLoading: boolean;
  error: any;
  meta: PaginationMeta | null;
  generateMessage: string | null;
  estimatedLeads: number | null;
  runs: DailyLeadRun[];
  runsLoading: boolean;
  runsMeta: PaginationMeta | null;
  notifications: IcpAdjustmentNotification[];
  notificationsLoading: boolean;
  notificationsMeta: PaginationMeta | null;
  notificationsUnreadCount: number;
  markingAllRead: boolean;
}

export const initialState: DailyLeadLegacyState = {
  leads: [],
  selectedLead: null,
  loading: false,
  generating: false,
  detailLoading: false,
  error: null,
  meta: null,
  generateMessage: null,
  estimatedLeads: null,
  runs: [],
  runsLoading: false,
  runsMeta: null,
  notifications: [],
  notificationsLoading: false,
  notificationsMeta: null,
  notificationsUnreadCount: 0,
  markingAllRead: false,
};

const _dailyLeadReducer = createReducer(
  initialState,
  on(DailyLeadActions.loadDailyLeads, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DailyLeadActions.loadDailyLeadsSuccess, (state, { leads, meta }) => ({
    ...state,
    leads,
    meta,
    loading: false,
  })),
  on(DailyLeadActions.loadDailyLeadsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(DailyLeadActions.loadDailyLeadDetail, state => ({
    ...state,
    detailLoading: true,
    error: null,
  })),
  on(DailyLeadActions.loadDailyLeadDetailSuccess, (state, { lead }) => ({
    ...state,
    selectedLead: lead,
    detailLoading: false,
  })),
  on(DailyLeadActions.loadDailyLeadDetailFailure, (state, { error }) => ({
    ...state,
    detailLoading: false,
    error,
  })),
  on(DailyLeadActions.clearDailyLeadDetail, state => ({
    ...state,
    selectedLead: null,
    detailLoading: false,
  })),
  on(DailyLeadActions.generateDailyLeads, state => ({
    ...state,
    generating: true,
    error: null,
    generateMessage: null,
    estimatedLeads: null,
  })),
  on(DailyLeadActions.generateDailyLeadsSuccess, (state, { message, estimatedLeads }) => ({
    ...state,
    generating: false,
    generateMessage: message,
    estimatedLeads,
  })),
  on(DailyLeadActions.generateDailyLeadsFailure, (state, { error }) => ({
    ...state,
    generating: false,
    error,
  })),
  on(DailyLeadActions.loadDailyLeadRuns, state => ({
    ...state,
    runsLoading: true,
  })),
  on(DailyLeadActions.loadDailyLeadRunsSuccess, (state, { runs, meta }) => ({
    ...state,
    runs,
    runsMeta: meta,
    runsLoading: false,
  })),
  on(DailyLeadActions.loadDailyLeadRunsFailure, (state, { error }) => ({
    ...state,
    runsLoading: false,
    error,
  })),
  on(DailyLeadActions.loadNotifications, state => ({
    ...state,
    notificationsLoading: true,
  })),
  on(DailyLeadActions.loadNotificationsSuccess, (state, { notifications, meta, unreadCount }) => ({
    ...state,
    notifications,
    notificationsMeta: meta,
    notificationsUnreadCount: unreadCount,
    notificationsLoading: false,
  })),
  on(DailyLeadActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    notificationsLoading: false,
    error,
  })),
  on(DailyLeadActions.markAllNotificationsRead, state => ({
    ...state,
    markingAllRead: true,
  })),
  on(DailyLeadActions.markAllNotificationsReadSuccess, state => ({
    ...state,
    markingAllRead: false,
    notificationsUnreadCount: 0,
    notifications: state.notifications.map(n => ({ ...n, read_at: n.read_at || new Date().toISOString() })),
  })),
  on(DailyLeadActions.markAllNotificationsReadFailure, (state, { error }) => ({
    ...state,
    markingAllRead: false,
    error,
  })),
);

export function dailyLeadLegacyReducer(state: DailyLeadLegacyState | undefined, action: any) {
  return _dailyLeadReducer(state, action);
}
